import React from "react";

export default function About() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-12 text-white md:mt-14">
      <h1 className="text-4xl font-bold mb-6 text-lime-400">About IQCAGE</h1>

      <p className="mb-6 text-lg leading-relaxed">
        <strong>IQCAGE</strong> is a next-generation crypto gaming platform that
        brings together the thrill of competitive gaming with the transparency
        and efficiency of blockchain technology. Founded with a vision to create
        a fair, skill-based, and decentralized gaming ecosystem, IQCAGE empowers
        players worldwide to compete, earn, and enjoy games in an entirely new
        way.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4 text-lime-300">
        🎮 Our Mission
      </h2>
      <p className="mb-6 text-lg leading-relaxed">
        We aim to revolutionize online gaming by removing the limitations of
        traditional systems. At IQCAGE, we champion player freedom, ownership of
        rewards, and real-time peer-vs-peer competition. Every move you make is
        powered by smart logic, and every reward you earn is yours to keep.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4 text-lime-300">
        🚀 What Makes Us Different
      </h2>
      <ul className="list-disc pl-6 space-y-3 text-lg">
        <li>
          <strong>Real Crypto Winnings:</strong> Win real USDT in every match —
          instant payouts, no hidden fees.
        </li>
        <li>
          <strong>Skill-Based Play:</strong> No luck involved. Win with pure
          strategy, reflexes, or smart thinking.
        </li>
        <li>
          <strong>Provably Fair:</strong> Transparent game logic and rules,
          powered by smart backend tech.
        </li>
        <li>
          <strong>Instant Matches:</strong> Play with real users or challenge
          our advanced AI bots 24/7.
        </li>
        <li>
          <strong>Zero House Edge:</strong> We take a small service fee, the
          rest goes directly to the players.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-10 mb-4 text-lime-300">
        🌍 Our Vision
      </h2>
      <p className="mb-6 text-lg leading-relaxed">
        We believe in a future where gaming isn’t just entertainment — it’s a
        global economy. With IQCAGE, gamers from any country can earn meaningful
        income, compete fairly, and grow their skills while having fun.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4 text-lime-300">
        🔐 Trust & Transparency
      </h2>
      <p className="mb-6 text-lg leading-relaxed">
        Your security is our top priority. We use top-grade encryption, secure
        wallet transactions, and transparent payout mechanisms to ensure your
        funds and data are always safe.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4 text-lime-300">
        📈 Join the Future of Gaming
      </h2>
      <p className="mb-6 text-lg leading-relaxed">
        Whether you’re a casual player or a hardcore competitor, IQCAGE is your
        arena. Play games like Tic-Tac-Toe (XO), Rock Paper Scissors (RPS), and
        more with crypto stakes. Invite friends, earn rewards, and become part
        of a bold new gaming era.
      </p>

      <p className="text-gray-400 text-sm mt-12">
        🧠 IQCAGE is built for gamers, traders, and Web3 pioneers. We invite you
        to explore, play, and grow with us — one match at a time.
      </p>
    </div>
  );
}
